// Versão do app - gerado automaticamente
export const APP_VERSION = '5.32'
export const BUILD_DATE = '06/05/2026, 22:32'
